import { useSelector } from "react-redux";
import { TableColumnGrouped } from "shared/ui-kit";

import { ScreenerStore, ScreenerStoreData, ScreenerStorePreference } from "../redux/model";

import ByCurrencyColumnConfigurations from './ScreenerTableComponent.columns';

import styles from './ScreenerTableComponent.module.scss';

export const ScreenerTableComponent = () => {
	const preference = useSelector<ScreenerStore, ScreenerStorePreference>(x => x.preference);
	const data = useSelector<ScreenerStore, ScreenerStoreData>(x => x.data);
	
	if (data.filteredEtfs.length === 0)
		return <p className={styles.no_data}>По указанным критериям фильтрации не было найдено ни одного ЕТФ или БПИФ</p>

	const columnConfiguration = ByCurrencyColumnConfigurations[preference.currency];
	return (
		<TableColumnGrouped items={data.filteredEtfs} columnConfiguration={columnConfiguration} getUniqueId={etf => etf.ticker}></TableColumnGrouped>
	);
};
